import * as React from "react";

const SvgComponent = ({ color = "#FFE500", ...props }) => (
  <svg
    width={20}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.725 9.956V8.45h.565c.61 0 1.13-.522 1.13-1.13V4.68c0-.609-.521-1.131-1.13-1.131h-.565V2.043c0-.609-.522-1.13-1.13-1.13H1.52c-.609 0-.942.563-.942 1.172v7.829c0 .609.333 1.173.942 1.173h15.073c.61 0 1.131-.522 1.131-1.13Zm-15.639 0c-.055 0-.188-.133-.188-.188V2.42c0-.056.133-.189.188-.189h14.132c.055 0 .188.133.188.189v7.348c0 .055-.133.188-.188.188H2.086Zm.189-7.348V9.58h13.754V2.654L2.275 2.608Z"
      fill={color}
    />
    <path
      d="M17.725 9.956V8.45h.565c.61 0 1.13-.522 1.13-1.13V4.68c0-.609-.521-1.131-1.13-1.131h-.565V2.043c0-.609-.522-1.13-1.13-1.13H1.52c-.609 0-.942.563-.942 1.172v7.829c0 .609.333 1.173.942 1.173h15.073c.61 0 1.131-.522 1.131-1.13Zm-15.639 0c-.055 0-.188-.133-.188-.188V2.42c0-.056.133-.189.188-.189h14.132c.055 0 .188.133.188.189v7.348c0 .055-.133.188-.188.188H2.086Z"
      fill="#222"
    />
  </svg>
);

export default SvgComponent;